<div class="my-4 mx-5">
    <div class="wrapper mb-5">
        <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Resgate de Créditos</span>
        </div>
        <div class="component-box container-fluid mb-0">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-12 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Estes são os produtos do favorecido:
                                    <span class="bold"> {{colaborador?.nome }} {{ colaborador?.sobrenome }}</span>
                                </h5>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                                <thead>
                                    <th>Produto</th>
                                    <th>Categoria do Produto</th>
                                    <th>Valor</th>
                                    <th>Status</th>
                                    <th></th>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell" *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                                        <td> {{ product?.nomeBeneficio }} </td>
                                        <td> {{ product?.produtoCategoriaDescricao }} </td>
                                        <td> {{ (product?.valorBeneficio <=0 ) ? 'R$ 0,00' : product?.valorBeneficio | currency:'BRL':true}} </td>
                                        <td> {{ product?.ativo ? 'Ativo' : 'Inativo' }} </td>
                                        <td>
                                            <div ngbDropdown class="d-inline-block menu-option" placement="left">
                                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                                    <img src="assets/icons/menu.png" />
                                                </button>
                                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                    <section class="custom-context-menu">
                                                        <div ngbDropdownItem (click)="ShowModal(modalResgatarBeneficio, product)">
                                                            <img src="assets/icons/pencil-purple.png" class="mr-2" /> Resgatar crédito
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div *ngIf="collaboratorDetailsModel?.currentProduct.length === 0" class="text-center">
                                <h6>
                                    Nenhuma intenção de depósito carregada. Faça uma
                                    busca para retornar a lista de intenções de depósito
                                    ou faça uma inteção de depósito.
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="component-box container-fluid">
            <div class="container-fluid pt-4">

                <div class="row">
                    <div class="col-12 text-left">
                        <ul class="options-cadastro pl-0">
                            <li>
                                <h5>Histórico</h5>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                                <thead>
                                    <th>Produto</th>
                                    <th>Valor</th>
                                    <th>Data do Resgate</th>
                                    <th>Gestor Responsável</th>
                                    <th class="width-max">Justificativa</th>
                                    <td>Ações</td>
                                </thead>
                                <tbody class="list-table-row">
                                    <tr class="list-table-cell"  *ngFor="let resgate of historicoResgate">
                                        <td>{{ resgate.nomeProduto }}</td>
                                        <td>{{ resgate.valor | currency:'BRL':true }}</td>
                                        <td>{{ resgate.dataResgate | date: "dd/MM/yyyy HH:mm" }}</td>
                                        <td>{{ resgate.nomeGestorResponsavel }}</td>
                                        <td class="width-max">{{ resgate.observacao | textFixed}}</td>
                                        <td>
                                            <div ngbDropdown class="d-inline-block menu-option" placement="left">
                                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                                    <img src="assets/icons/menu.png" />
                                                </button>
                                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                                    <section class="custom-context-menu">
                                                        <div ngbDropdownItem (click)="OpenObservacao(modalObservacao, resgate.observacao)">
                                                            <img src="assets/icons/bill.png" class="mr-2" /> Ver justificativa
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div
                                *ngIf="collaboratorDetailsModel?.currentProduct.length === 0"
                                class="text-center"
                            >
                                <h6>
                                    Nenhuma intenção de depósito carregada. Faça uma
                                    busca para retornar a lista de intenções de depósito
                                    ou faça uma inteção de depósito.
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalResgatarBeneficio let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Resgatar crédito</h5>
            <p class="clean-modal-subtitle">
                Qual o valor que gostaria de resgatar?
            </p>

            <p class="clean-modal-warning">
                <img class="img-status" src="./assets/icons/status-yellow.png" /> Esta ação é irreversível, ao clicar em <b>resgatar</b>, o valor informado no campo <b>digite o valor</b> será debitado da conta do favorecido. Será mantido o histórico
                dos resgates de crédito, e o favorecido será informado via aplicativo consumidor da justificativa para resgate do crédito.
            </p>
            <p class="clean-modal-subtitle text-center">
                <small>

                </small>
            </p>
        </div>
    </div>

    <ng-container *ngIf="beneficioValorSelecionado?.valorBeneficio > 0">
        <div class="col-12 clean-modal-content text-center">
            <div class="custom-filter-input-container d-flex justify-content-center">
                <mat-form-field class="w-75">
                    <mat-label>Digite o valor</mat-label>
                    <input [formControl]="valueCtrl" matInput type="text" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" >
                    <mat-hint align="start">O saldo disponível para transferência é de <strong>{{ beneficioValorSelecionado.valorBeneficio | currency:'BRL':true}}</strong> </mat-hint>
                  </mat-form-field>

                <!-- <mat-form-field class="w-75">
                    <mat-label>Digite o valor</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                </mat-form-field> -->
            </div>

            <div class="custom-filter-input-container d-flex justify-content-center">
                <mat-form-field class="w-75">
                    <mat-label>Justificativa <span>(obrigatório)</span></mat-label>
                    <textarea matInput [formControl]="justifyCtrl" [value]="justificativa"></textarea>
                </mat-form-field>
            </div>

            <span class="message-error" *ngIf="message && message != ''">
                {{ message }}
            </span>

        </div>
    </ng-container>

    <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio == 0"> Não existe valor para resgate </h4>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="ResgatarBeneficio()">
            Resgatar
        </button>
    </div>
</ng-template>

<ng-template #modalObservacao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Observações
            </h5>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text text-center">
            <p *ngIf="observacaoSelecionada">
                {{ observacaoSelecionada }}
            </p>
            <h4 class="text-center" *ngIf="!observacaoSelecionada"> Não existe observação para o resgate </h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<!--ng-template #modalResgatarBeneficio let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Resgatar crédito
            </h5>
            <p class="clean-modal-subtitle" *ngIf="beneficioValorSelecionado?.valorBeneficio > 0">
                Qual o valor que gostaria de resgatar?
            </p>

            <p class="clean-modal-warning">
                <img class="img-status" src="./assets/icons/status-yellow.png" /> Esta ação é irreversível, ao clicar em <b>resgatar</b>, o valor informado no campo <b>digite o valor</b> será debitado da conta do favorecido. Será mantido o histórico
                dos resgates de crédito, e o favorecido será informado via aplicativo consumidor da justificativa para resgate do crédito.
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <form *ngIf="beneficioValorSelecionado?.valorBeneficio > 0">
                <div class="form-group">
                    <div class="clean-modal-section-title">Digite o valor</div>
                    <input type="text" class="w-75" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" (change)="ClearMessage()" (keypress)="ClearMessage()" />
                    <span class="legend">
                        O saldo disponível para resgate é de {{ beneficioValorSelecionado?.valorBeneficio | currency:'BRL':true }}
                    </span>

                    <div class="clean-modal-section-title m-t-15p">Justificativa <span>(obrigatório)</span></div>
                    <textarea rows="5" class="w-75" #inObservacao></textarea>

                    <span class="message-error" *ngIf="message">
                        {{ message }}
                    </span>
                </div>
                <button class="custom-filter-button" (click)="ResgatarBeneficio(valor.value, inObservacao.value)">
                    Resgatar
                </button>
            </form>

            <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio == 0"> Não existe valor para resgate </h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<ng-template #modalObservacao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Observações
            </h5>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p *ngIf="observacaoSelecionada">
                {{ observacaoSelecionada }}
            </p>
            <h4 class="text-center" *ngIf="!observacaoSelecionada"> Não existe observação para o resgate </h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template-->

<!--
    <div class="container-fluid">
    <div class="row">
        <span class="list-header-title">Resgate de Créditos</span>
    </div>
</div>

<div class="container-fluid">

    <div class="row">
        <div class="col-9 rm-padding">
            <p>Estes são os produtos do favorecido: <span class="bold"> {{colaborador?.nome }} {{ colaborador?.sobrenome }} </span></p>
        </div>
        <div class="col-3 text-right rm-padding">
            <button class="custom-button-back" (click)="goToBack()">
                Voltar
            </button>
        </div>
    </div>



    <div class="row">
        <div class="list-box col-12">
            <table class="list-table table">
                <thead class="list-table-head">
                    <th>Produtos</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th></th>
                </thead>
                <tbody class="list-table-row">
                    <tr class="list-table-cell" *ngFor="let product of collaboratorDetailsModel?.currentProduct">
                        <td> {{ product?.nomeBeneficio }} </td>
                        <td> {{ (product?.valorBeneficio <=0 ) ? 'R$ 0,00' : product?.valorBeneficio | currency: 'BRL':true }} </td>

                                <td> Ativo </td>
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                    menu-option">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" /></button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="ShowModal(modalResgatarBeneficio,
                                                product)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" /> Resgatar crédito
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row mt-5">
        <h5>Histórico :</h5>
    </div>

    <div class="row">
        <div class="table-responsive">
            <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
                <thead class="list-table-head b-t-custom">
                    <th>Produto</th>
                    <th>Valor</th>
                    <th>Data do Resgate</th>
                    <th>Gestor Responsável</th>
                    <th class="width-max">Justificativa</th>
                    <td>Ações</td>
                </thead>
                <tbody>
                    <tr class="list-table-row" *ngFor="let resgate of historicoResgate">
                        <td>{{ resgate.nomeProduto }}</td>
                        <td>{{ resgate.valor | currency:'BRL':true }}</td>
                        <td>{{ resgate.dataResgate | date: "dd/MM/yyyy HH:mm" }}</td>
                        <td>{{ resgate.nomeGestorResponsavel }}</td>
                        <td class="width-max">{{ resgate.observacao | textFixed}}</td>
                        <td>
                            <div ngbDropdown class="d-inline-block menu-option" placement="left">
                                <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                    <img src="assets/icons/menu.png" />
                                </button>

                                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                    <section class="custom-context-menu">
                                        <div ngbDropdownItem (click)="OpenObservacao(modalObservacao, resgate.observacao)">
                                            <img src="assets/icons/bill.png" class="mr-2" /> Ver justificativa
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div *ngIf="historicoResgate.length == 0" class="text-center">
                <h6>
                    Nenhum resgate realizado
                </h6>
            </div>

        </div>
    </div>
</div>

<ng-template #modalResgatarBeneficio let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Resgatar crédito
            </h5>
            <p class="clean-modal-subtitle" *ngIf="beneficioValorSelecionado?.valorBeneficio > 0">
                Qual o valor que gostaria de resgatar?
            </p>

            <p class="clean-modal-warning">
                <img class="img-status" src="./assets/icons/status-yellow.png" /> Esta ação é irreversível, ao clicar em <b>resgatar</b>, o valor informado no campo <b>digite o valor</b> será debitado da conta do favorecido. Será mantido o histórico
                dos resgates de crédito, e o favorecido será informado via aplicativo consumidor da justificativa para resgate do crédito.
            </p>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <form *ngIf="beneficioValorSelecionado?.valorBeneficio > 0">
                <div class="form-group">
                    <div class="clean-modal-section-title">Digite o valor</div>
                    <input type="text" class="w-75" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" (change)="ClearMessage()" (keypress)="ClearMessage()" />
                    <span class="legend">
                        O saldo disponível para resgate é de {{ beneficioValorSelecionado?.valorBeneficio | currency:'BRL':true }}
                    </span>

                    <div class="clean-modal-section-title m-t-15p">Justificativa <span>(obrigatório)</span></div>
                    <textarea rows="5" class="w-75" #inObservacao></textarea>

                    <span class="message-error" *ngIf="message">
                        {{ message }}
                    </span>
                </div>
                <button class="custom-filter-button" (click)="ResgatarBeneficio(valor.value, inObservacao.value)">
                    Resgatar
                </button>
            </form>

            <h4 class="text-center" *ngIf="beneficioValorSelecionado?.valorBeneficio == 0"> Não existe valor para resgate </h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<ng-template #modalObservacao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Observações
            </h5>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p *ngIf="observacaoSelecionada">
                {{ observacaoSelecionada }}
            </p>
            <h4 class="text-center" *ngIf="!observacaoSelecionada"> Não existe observação para o resgate </h4>
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template-->
